<!--
Author: TangChen
Date: 2018-10-17
Desc: 找回交易密码，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-reset-tpwd bizcomp ' + className">
        <comp-title :title="title" />
        <nav-tips :data="titTips" />
        <reset-pwd :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navTips from "@/components/form/navTips.vue";
import resetPwd from "@/components/acctInfo/resetPwd.vue";
export default {
    name: "Resettpwd",
    components: {
        navTips,
        resetPwd
    },
    mixins: [mixin],
    data () {
        return {
            titTips: {
                tit: "找回交易密码",
                text: "交易密码用于下单等关键交易操作的安全验证",
                cla: "trade-pwd"
            },
            way: "trade"
        };
    },
    methods: {
    // 账户绑定选项处理
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.bizcomp-reset-tpwd {
}
</style>
